<template>
  <div class="task-deadline">
    <TirPmDatepicker
      v-model="date"
      :is-disabled="!editing"
      :input="{ label: 'Дедлайн', isSmall: true }"
      :type="DatepickerTypeEnum.DateTime"
      @blur="onBlur"
      @enter="onEnter"
      @save="updateDeadline"
    />
  </div>
</template>

<script lang="ts" setup>
import { PropType, ref, watch } from "vue";
import { DatepickerTypeEnum, TirPmDatepicker } from "tir-components";

const emit = defineEmits<{
  /**Событие обновления выбранной даты */
  (e: "update:modelValue", value: Date): void;
}>();

const props = defineProps({
  /**Возможность редактировать */
  editing: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  /**Значение */
  modelValue: {
    type: Object as PropType<Date>,
    required: true,
  },
});

/**Внутренне значение даты */
const date = ref(props.modelValue);
/**Отслеживаем изменение даты извне */
watch(
  () => props.modelValue,
  () => {
    date.value = new Date(props.modelValue);
  },
  { deep: true },
);

/**Обновить дедлайн */
const updateDeadline = () => {
  if (date.value) {
    if (date.value.getTime() !== props.modelValue.getTime())
      emit("update:modelValue", new Date(date.value));
  } else {
    date.value = new Date(props.modelValue);
  }
};

/**При событии blur */
const onBlur = (isCorrectDate: boolean) => {
  // Обновлеяем дату если она корректная
  if (isCorrectDate) updateDeadline();
};
/**При событии enter */
const onEnter = (isCorrectDate: boolean) => {
  // Обновлеяем дату если она корректная
  if (isCorrectDate) updateDeadline();
};
</script>

<style lang="scss" scoped></style>
